import classes from './BelowTheFoldPlaceholder.module.scss'

// `loading` state of the BelowTheFold dynamic import, reserving the deferred
// sections' height. Fixes CLS: PageBackground's blobs are positioned as a
// percentage of the wrapper height, so without this they shift when the chunk
// mounts (0.064). Kept out of BelowTheFold.tsx to stay in the page bundle.
export const BelowTheFoldPlaceholder = () => (
  <div className={classes.placeholder} aria-hidden />
)
